export default __webpack_public_path__ + "static/media/javascript.acc4642f.svg";